import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const numClampUiNodeSpec: UiNodeSpec<'numClamp'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { max: 0, min: 0 }, id: getUID(), kind: 'numClamp', disabled: false }),
    controls: getNodeCfg => ({
        max: { cfg: { kind: 'number', label: 'Max' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.max },
        min: { cfg: { kind: 'number', label: 'Min' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.min },
    }),
    inputs: () => ({ input: { socket: 'number', label: 'Input' } }),
    kindLabel: 'Number Clamp',
    nodeCategory: 'number',
    outputs: () => ({ output: { socket: 'number', label: 'Output' } }),
    validator: node => {
        const errors: Record<string, string> = {};
        if (node.controlValues.min && node.controlValues.max && node.controlValues.min > node.controlValues.max) {
            errors.min = 'Min must be less than or equal to Max';
            errors.max = 'Max must be greater than or equal to Min';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
